import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    filter: require('lodash/filter'),
    map: require('lodash/map'),
    forEach: require('lodash/forEach'),
    isEqual: require('lodash/isEqual'),
    isEmpty: require('lodash/isEmpty'),
};

const Globals = require('../../../../app/globals');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const GlobalUserStore = require('../../stores/GlobalUserStore');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const ActivityStore = require('../../stores/activity_store_reflux');

import SortableTableClassic from '../table/SortableTableClassic';
import LoadingSpinner from '../loading/LoadingSpinner';
import MultiFilterPaginationControls from '../table/MultiFilterPaginationControls';

const propTypes = {};
const defaultProps = {};

const FEEDBACK_COLUMNS = [
  /*{
        displayName: 'ID',
        key:'id',
        size: 1,
        type: 'int',
    },*/
    {
        displayName: 'Channel',
        key:'channel_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Activity Name',
        key:'activity_name',
        size: 5,
        type: 'string',
    },
    {
        displayName: 'Version',
        key:'version',
        size: 1,
        type: 'string',
    },
    {
        displayName: 'Create Date',
        key:'created_at',
        size: 2,
        type: 'date',
    },
    {
        displayName: 'Reporter',
        key:'user_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Assigned To',
        key: 'assigned_user_display_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Category',
        key:'category',
        size: 1,
        type: 'string',
    },
    {
        displayName: 'Comment',
        key:'comment',
        size: 6,
        type: 'string',
    },
];

class AdminStudentFeedbackView extends React.Component {
    constructor(props) {
        super(props);
        let feedbackStoreState = AdminGlobalUserStore.getFeedbackCommentState();
        let feedback_categories = GlobalUserStore.getState().feedback_categories;
        let commentSearchTerm = '';
        let categorySearchTerm = [];
        let sortBy = '';
        let sortOrder = '';
        let page = 1;
        let categoryOptions = [];
        if (feedbackStoreState && feedbackStoreState.initializedFeedbackComments) {
            commentSearchTerm = feedbackStoreState.commentSearchTerm || '';
            categorySearchTerm = feedbackStoreState.categorySearchTerm || [];
            sortBy = feedbackStoreState.sortBy;
            sortOrder = feedbackStoreState.sortOrder;
            page = feedbackStoreState.page;
        }
        if (feedback_categories) {
            categoryOptions = feedback_categories.slice();
            categoryOptions.push({id:null, name:'none'});
            categorySearchTerm = _.map(categoryOptions,'id');
        }
        
        this.state = {
            feedbackStoreState,
            commentSearchTerm,
            categoryOptions, categorySearchTerm,
            sortBy,
            sortOrder,
            page,
            actionId: null,
            categoryActionId: null,
        }
        this.unsubscribes = [
            GlobalUserStore.listen(this.onUserStoreChange),
            AdminGlobalUserStore.listen(this.onAdminUserStoreChange),
        ];
    }

    componentDidMount() {
        if (!this.state.feedback_categories) {
            this.doRequestCategories();
        }
        else if (!this.state.feedbackStoreState.initializedFeedbackComments) {
            this.doRequestData();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onUserStoreChange=(newState)=>{
        const categoryActionMatch = (newState.action.id === this.state.categoryActionId);
        if (categoryActionMatch) {
            let feedback_categories = GlobalUserStore.getState().feedback_categories;
            let categoryOptions = feedback_categories.slice();
            let categorySearchTerm = _.map(categoryOptions,'id');
            let changes = {feedback_categories, categoryOptions, categorySearchTerm, categoryActionId:null};
            this.setState(changes,()=>{
                if (!this.state.feedbackStoreState.initializedFeedbackComments) {
                    this.doRequestData();
                }
            });
        }
    }

    onAdminUserStoreChange=(newState)=>{
        const actionMatch = (newState.action.id === this.state.actionId);
        const updateActionMatch = (newState.action.id === this.state.updateActionId);
        if (actionMatch || updateActionMatch) {
            let feedbackStoreState = AdminGlobalUserStore.getFeedbackCommentState();
            let changes = {feedbackStoreState};
            if (actionMatch) {
                changes.actionId = null;
            }
            if (updateActionMatch) {
                changes.updateActionId = null;
            }
            this.setState(changes);
        }
    }
    
    handleOptionsFilter=(key,id,value,options)=>{
        let values = [];
        const oldValues = this.state[key];
        _.forEach(options,(cat)=>{
            if (cat.id === id) {
                if (value) {
                    values.push(id);
                }
            }
            else if (oldValues.indexOf(cat.id) >= 0) {
                values.push(cat.id);
            }
        });
        this.setState({[key]: values});
    }
    
    onFilterChange=(key,value,id)=>{
        switch(key) {
            case 'commentSearchTerm':
                this.setState({commentSearchTerm: value});
                return;
            case 'categorySearchTerm':
                return this.handleOptionsFilter(key,id,value,this.state.feedback_categories);
        }
        console.log(`onFilterChange(${key},${value},${id}) not handled`);
    }

    requestPage=(page)=>{
        this.setState({page},this.doRequestData);
    }
    
    onSortChange=(sortKey,asc)=>{
        this.setState({
            sortBy: sortKey,
            sortOrder: asc ? 'asc' : 'desc',
        },this.doRequestData);
    }
    
    doRequestData=()=>{
        let actionId = uuid.v4();
        const params = {
            page: this.state.page,
            commentSearchTerm: this.state.commentSearchTerm.trim(),
            categorySearchTerm: this.state.categorySearchTerm,
            sortBy: this.state.sortBy,
            sortOrder: this.state.sortOrder,
        }
        if (this.state.feedbackStoreState && this.state.feedbackStoreState.initializedFeedbackComments) {
            if (this.state.feedbackStoreState.studentFeedbackPagination.numPages < 2) {
                // get all the records and apply the filters on the client
                params.commentSearchTerm = '';
                params.categorySearchTerm = null;
            }
        }

        this.setState({actionId},()=>{
            GlobalUserActions.getAdminStudentFeedback(actionId, params);
        });
    }
    
    doRequestCategories=()=>{
        let categoryActionId = uuid.v4();
        this.setState({categoryActionId},()=>{
            GlobalUserActions.getStudentFeedbackCategories(categoryActionId);
        });
    }
    
    onCommentClick=(e,selectedId)=>{
        if (this.state.updateActionId) {
            this.setState({selectedFeedbackNote:"Please wait. Update pending."}); // this UI can only handle one update at a time
            return;
        }
        if (this.state.selectedFeedbackChanges) {
            this.setState({selectedFeedbackNote:"close or update before selecting another row"}); // this UI can only handle one update at a time
            return;
        }
        this.setState({selectedId, selectedFeedbackChanges:null});
    }
    
    onChangeCategory=(id,val)=>{
        var category_id = Number(val);
        const feedback_comments = this.state.feedbackStoreState.feedback_comments;
        const selectedFeedback = _.find(feedback_comments,{id:this.state.selectedId});
        var selectedFeedbackChanges = null;
        if (selectedFeedback.category_id !== category_id) {
            selectedFeedbackChanges = { id, category_id };
        }
        this.setState({selectedFeedbackChanges});
    }
    
    updateSelectedFeedback=()=>{
        let params = this.state.selectedFeedbackChanges;
        if (!params) {
            return;
        }
        let updateActionId = uuid.v4();
        this.setState({updateActionId,selectedFeedbackChanges:null,selectedFeedbackNote:''},()=>{
            GlobalUserActions.updateAdminStudentFeedback(updateActionId,params);
        });
    }

    deselectRow=()=>{
        this.setState({
            selectedId:null, 
            selectedFeedbackChanges: null,
            selectedFeedbackNote: '',
        });
    }

    goToComment=()=>{
        const feedback_comments = this.state.feedbackStoreState.feedback_comments;
        const comment = _.find(feedback_comments,{id:this.state.selectedId});
        if (comment && comment.activity_id) {
            let route_suffix = '/review'; // punt. could check for lock and try edit
            let url = `/project/${comment.channel_id}/${comment.project_id}/activity/${comment.activity_id}${route_suffix}`;
            
            // tell the editor to navigate to the particular comment, after giving it a chance to load.
            ActivityStore.setEditGotoComment(comment.activity_id, comment.id, comment.location);
            this.props.history.push(url);
            // window.location = url;
        }
    }

    getIntegrationTypeDisplayName=(integrationType)=>{
        switch (integrationType) {
            case Globals.integration_type.GOOGLE_CLASSROOM:
                return 'Google Classroom';
            case Globals.integration_type.LOCAL:
                return 'Local';
            case Globals.integration_type.LTI:
                return 'LTI 1.1';
            case Globals.integration_type.LTI_1_3:
                return 'LTI 1.3';
            case Globals.integration_type.CONNECT:
                return 'Connect';
        }
        return '';
    }

    render() {
        const self = this;
        if (!this.state.feedbackStoreState || !this.state.feedbackStoreState.initializedFeedbackComments || !this.state.feedback_categories) {
            return (
                <div>
                    <LoadingSpinner/>
                </div>
            );
        }

        const ssp = this.state.feedbackStoreState.studentFeedbackPagination;
        const currentPage = ssp.currentPage;
        const numPages = ssp.numPages;
        const filterPages = ssp.filterPages;
        const totalRecords = ssp.totalRecords;

        let anySearchTerms = false;
        if (this.state.commentSearchTerm || this.state.categorySearchTerm) {
            anySearchTerms = true;
        }

        let searchTermsApplied = true;
        if ((this.state.commentSearchTerm.trim() !== ssp.commentSearchTerm) ||
            (!_.isEqual(this.state.categorySearchTerm,ssp.categorySearchTerm))) {
            searchTermsApplied = false;
        }

        const searchTerms = {
            commentSearchTerm: {
                name: "Comment",
                searchTerm: this.state.commentSearchTerm,
            },
            categorySearchTerm: {
                name: "Category",
                searchTerm: this.state.categorySearchTerm,
                options: this.state.categoryOptions,
                
            },
        };
        
        const feedback_categories = this.state.feedback_categories;
        let feedback_comments = this.state.feedbackStoreState.feedback_comments.map((elem)=>{
            let row = {...elem};
            row.user_name = elem.user_display_name;
            if (feedback_categories) {
                row.category = find(feedback_categories.categories,{id:elem.category_id}) || '';
            }            
            if (!row.user_name) {
                row.user_name = `${elem.user_last_name || ''}, ${elem.user_first_name || ''}`;
            }
            let category = _.find(this.state.feedback_categories,{id: row.category_id}) || {name:''};
            row.category = category.name;
            return row;
        });
        
        // if all the records fit on one page, filter on the client 
        if (numPages < 2) {
            const commentSearchTerm = this.state.commentSearchTerm;
            let categorySearchTerm = this.state.categorySearchTerm;
            if (categorySearchTerm && !categorySearchTerm.length) {
                categorySearchTerm = null;
            }
            let doFilter=(feedbackObj)=>{
                return (
                     (!commentSearchTerm || (feedbackObj.comment && (feedbackObj.comment.toLowerCase().indexOf(commentSearchTerm) >= 0)) ) &&
                     (!categorySearchTerm || (categorySearchTerm.indexOf(feedbackObj.category_id) >= 0 ))
                );
            };
            feedback_comments = _.filter(feedback_comments, (entry) => {
                return doFilter(entry);
            });
        }
        
        const selectedFeedback = _.find(feedback_comments,{id:this.state.selectedId});
        let selectedRowUI = null;
        if (selectedFeedback) {
            const categories = this.state.feedback_categories;
            let category_id = this.state.selectedFeedbackChanges ? this.state.selectedFeedbackChanges.category_id : selectedFeedback.category_id;
            selectedRowUI = (
                <Card className="selected-feedback-comment" body bg="light">
                    <h2 className="large-heading-regular margin-bottom-md">
                        {"Selected Feedback Comment"}
                    </h2>
                    <Form className="indented">
                     {/*<div className="row">
                            <label>ID:</label>
                            <span>{selectedFeedback.id}</span>
                        </div>*/}
                        <div className="row">
                            <label>Category:</label>
                            <select value={category_id || ''} onChange={(e)=>{this.onChangeCategory(this.state.selectedId,e.target.value) }}>
                            {categories.map((obj)=>(
                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                            ))}
                            <option hidden key={'n'} value=''>{'Select category...'}</option>
                            </select>
                        </div>
                        <div className="row">
                            <label>{'Date/Time:'}</label>
                            <span>{selectedFeedback.created_at}</span>
                        </div>
                        <div className="row">
                            <label>{'Channel:'}</label>
                            <span>{selectedFeedback.channel_name}</span>
                        </div>
                        <div className="row">
                            <label>{'Activity:'}</label>
                            <span>{selectedFeedback.activity_name + (selectedFeedback.version ? ` version ${selectedFeedback.version}` : '')}</span>
                        </div>
                        <div className="row">
                            <label>{'Template:'}</label>
                            <span>{selectedFeedback.template_name}</span>
                        </div>
                        <div className="row">
                            <label>{'Reporter:'}</label>
                            <span>{selectedFeedback.user_display_name || (`${selectedFeedback.user_last_name}, ${selectedFeedback.user_first_name}`)}</span>
                        </div>
                        <div className="row">
                            <label>{'Assigned To:'}</label>
                            <span>{selectedFeedback.assigned_user_display_name || (`${selectedFeedback.assigned_user_last_name}, ${selectedFeedback.assigned_user_first_name}`)}</span>
                        </div>
                        <div className="row">
                            <label>{'Integration Type:'}</label>
                            <span>{this.getIntegrationTypeDisplayName(selectedFeedback.launch_type)}</span>
                        </div>
                        <div className="row">
                            <label>{'Assignment:'}</label>
                            <span>{selectedFeedback.assignment_name}</span>
                        </div>
                        <div className="row">
                            <label>{'Element:'}</label>
                            <span>{JSON.stringify(selectedFeedback.location)}</span>
                        </div>
                        <div className="row">
                            <label>{'Comment:'}</label>
                            <span>{selectedFeedback.comment}</span>
                        </div>
                    </Form>
                    {this.state.selectedFeedbackNote ? <div className="note">{this.state.selectedFeedbackNote}</div> : null }
                    <Button disabled={!this.state.selectedFeedbackChanges} onClick={this.updateSelectedFeedback}>Update</Button>
                    <Button onClick={this.deselectRow}>Close</Button>
                    {selectedFeedback.activity_id ? <Button onClick={this.goToComment}>Go To Comment</Button> : null}
                </Card>
            );
        }

        return (
            <div className="admin-student-feedback-view">
                <MultiFilterPaginationControls
                    id="admin-student-feedback-pagination"
                    className="margin-bottom-lg"
                    currentPage={currentPage}
                    numPages={numPages}
                    anySearchTerms={anySearchTerms}
                    searchTermsApplied={searchTermsApplied}
                    filterPages={filterPages}
                    totalRecords={totalRecords}
                    requestPage={this.requestPage}
                    searchTerms={searchTerms}
                    onFilterChange={this.onFilterChange}
                    doApplySearchTerms={this.doRequestData}
                />
                {selectedRowUI}
                <SortableTableClassic
                    key="t-feedback"
                    title="Feedback"
                    hideFilter
                    uniqueRowKey={"id"}
                    onRowClick={this.onCommentClick}
                    onSortChange={this.onSortChange}
                    rows={feedback_comments}
                    selectedRowKey={!!this.state.selectedComment ? this.state.selectedComment.id : null}
                    dateFormat="YYYY-MM-DD HH:mm:ss"
                    columns={FEEDBACK_COLUMNS}
                />
                {this.state.selectedComment ?
                    <span>TODO selected comment details</span>
                : null }
            </div>
        );
    }
}

AdminStudentFeedbackView.propTypes = propTypes;
AdminStudentFeedbackView.defaultProps = defaultProps;

export default AdminStudentFeedbackView;